<template>
  <div class="manage_page fillcontain">
    <el-row style="height: 100%;">
      <el-col
        :span="4"
        style="min-height: 100%; background-color: #ffffff;border-right: solid 1px #e6e6e6;"
      >
        <el-menu
          :default-active="defaultActive"
          style="min-height: 100%;border-style:none"
          theme="dark"
          router
          unique-opened
        >
          <el-menu-item index="information">
            <i class="el-icon-menu"></i>首页
          </el-menu-item>

          <el-submenu index="2">
            <template slot="title">
              <i class="el-icon-document"></i>广告主
            </template>
            <el-menu-item index="chooersmedia?i=1">媒体资源</el-menu-item>
            <el-menu-item index="addArticle">文章发布</el-menu-item>
            <el-menu-item index="manuscriptList">
              稿件管理
              <i class="red" v-if="num_1!=0">{{num_1}}</i>
            </el-menu-item>
            <el-menu-item index="myquestion">
              修改订单
              <i class="red" v-if="num_2!=0">{{num_2}}</i>
            </el-menu-item>
          </el-submenu>

          <el-submenu index="3">
            <template slot="title">
              <i class="el-icon-plus"></i>资源主
            </template>
            <el-menu-item index="orderList">
              我的订单
              <i class="red" v-if="num_3!=0">{{num_3}}</i>
            </el-menu-item>
            <el-menu-item index="modificationList">
              订单修改
              <i class="red" v-if="num_4!=0">{{num_4}}</i>
            </el-menu-item>
            <el-menu-item index="mymediaList">媒体管理</el-menu-item>
            <el-menu-item index="myothermedia">媒体审核</el-menu-item>
          </el-submenu>
          <el-submenu index="4" v-show="showDistribution=='true'">
            <template slot="title">
              <i class="el-icon-plus"></i>一起推（分销）
            </template>
            <el-menu-item index="myfx">我的分销</el-menu-item>
            <el-menu-item index="myfxusers">分销用户</el-menu-item>
            <el-menu-item index="withdrawalfx">收益明细</el-menu-item>
          </el-submenu>
          <!-- <el-submenu index="4">
						<template slot="title"><i class="el-icon-star-on"></i>充值管理</template>
						<el-menu-item index="myData">个人信息</el-menu-item>
						<el-menu-item index="balanceRecharge">余额充值</el-menu-item>
						<el-menu-item index="rechargeList">充值记录</el-menu-item>
						<el-menu-item index="detailedList">账单明细</el-menu-item>
          </el-submenu>-->
          <!-- 
          <el-submenu index="4">
            <template slot="title">
              <i class="el-icon-edit"></i>我的媒体
            </template>

            <el-menu-item index="withdrawal">我的收益</el-menu-item>
          </el-submenu>-->

          <!-- <el-submenu index="6">
						<template slot="title"><i class="el-icon-setting"></i>设置</template>
						<el-menu-item index="adminSet">管理员设置</el-menu-item>
					</el-submenu>

					<el-submenu index="7">
						<template slot="title"><i class="el-icon-warning"></i>说明</template>
						<el-menu-item index="explain">说明</el-menu-item>
          </el-submenu>-->
          <div style="position: fixed;bottom:0;height:230px;margin-left:2%">
            <p style="margin-bottom:6px;font-weight:bold;font-size:14pt;height:40px">在线客服</p>
            <div style="margin-bottom:6px;margin-top:6px;height:30px">
              <img style="width: 20px;    float: left;" src="../assets/QQ.png" />
              <a
                style="float: left;"
                target="_blank"
                href="http://wpa.qq.com/msgrd?v=3&amp;uin=3454058863&amp;site=qq&amp;menu=yes"
              >在线客服1</a>
            </div>
            <div style="margin-bottom:6px;margin-top:6px;height:30px">
              <img style="width: 20px;    float: left;" src="../assets/QQ.png" />
              <a
                style="float: left;"
                target="_blank"
                href="http://wpa.qq.com/msgrd?v=3&amp;uin=3454007026&amp;site=qq&amp;menu=yes"
              >在线客服2</a>
            </div>
            <div style="margin-bottom:6px;margin-top:6px;height:30px">
              <img style="width: 20px;    float: left;" src="../assets/QQ.png" />
              <a
                style="float: left;"
                target="_blank"
                href="http://wpa.qq.com/msgrd?v=3&amp;uin=1197574586&amp;site=qq&amp;menu=yes"
              >在线客服3</a>
            </div>
            <div style="margin-bottom:6px;margin-top:6px;height:30px">
              <img style="width: 20px;    float: left;" src="../assets/QQ.png" />
              <a
                style="float: left;"
                target="_blank"
                href="http://wpa.qq.com/msgrd?v=3&amp;uin=3454088365&amp;site=qq&amp;menu=yes"
              >值班客服</a>
            </div>
            <div style="margin-bottom:6px;margin-top:6px;height:30px">
              <img style="width: 20px;    float: left;" src="../assets/QQ.png" />
              <a
                style="float: left;"
                target="_blank"
                href="http://wpa.qq.com/msgrd?v=3&amp;uin=1291621488&amp;site=qq&amp;menu=yes"
              >资源审核</a>
            </div>
          </div>
        </el-menu>
      </el-col>
      <el-col :span="20" style="height: 100%;overflow: auto;">
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import myAxios from "../myAxios";
export default {
  watch: {
    num_1: function() {
      this.num_1 = this.$global_msg.num_1;
    },
    num_2: function() {
      this.num_2 = this.$global_msg.num_2;
    },
    num_3: function() {
      this.num_3 = this.$global_msg.num_3;
    },
    num_4: function() {
      this.num_4 = this.$global_msg.num_4;
    }
  },
  data() {
    return {
      username: localStorage.getItem("username"),
      num_1: 0,
      num_2: 0,
      num_3: 0,
      num_4: 0,
      showDistribution:localStorage.getItem("isDistribution"),
    };
  },
  computed: {
    defaultActive: function() {
      return this.$route.path.replace("/", "");
    }
  },
  created() {},
  methods: {
    getNums() {
      myAxios
        .get(`/client_media/MyOrderCount/v1?username=${this.username}`)
        .then(res => {
          console.log(res);
          this.$global_msg.num_3 = res.data.orders;
          this.num_3 = this.$global_msg.num_3;
          sessionStorage.setItem("countData", JSON.stringify(res));
        });
      myAxios
        .get(`/client_user/MyOrderCount/v1?username=${this.username}`)
        .then(res => {
          console.log(res);
          this.$global_msg.num_1 = res.data.orders;
          this.num_1 = this.$global_msg.num_1;
          sessionStorage.setItem("countData2", JSON.stringify(res));
        });
      // myAxios
      //http://47.115.92.84:808/api/client_media/OrderQuestions/v1?username=cs1
      //   .get(`client_user/MyQuestions/v1?username=${this.username}&state=1`)
      //   .then(res => {
      //     this.$global_msg.num_2 = res.data.state_1;
      //     this.num_2 = this.$global_msg.num_2;
      //   });
      myAxios
        .get(`/client_media/OrderQuestions/v1?username=${this.username}`)
        .then(res => {
          this.$global_msg.num_4 = res.data.state_1;
          this.num_4 = this.$global_msg.num_4;
        });
    }
  },
  mounted() {
    // console.log("刷新了")
    // 资源主：client_media/MyOrderCount
    // 广告主：client_user/MyOrderCount
    myAxios
      .get(`/client_media/MyOrderCount/v1?username=${this.username}`)
      .then(res => {
        console.log(res);
        this.$global_msg.num_3 = res.data.orders;
        this.num_3 = this.$global_msg.num_3;
        sessionStorage.setItem("countData", JSON.stringify(res));
      });
    myAxios
      .get(`/client_user/MyOrderCount/v1?username=${this.username}`)
      .then(res => {
        console.log(res);
        this.$global_msg.num_1 = res.data.orders;
        this.num_1 = this.$global_msg.num_1;
        sessionStorage.setItem("countData2", JSON.stringify(res));
      });
    // myAxios
    //http://47.115.92.84:808/api/client_media/OrderQuestions/v1?username=cs1
    //   .get(`client_user/MyQuestions/v1?username=${this.username}&state=1`)
    //   .then(res => {
    //     this.$global_msg.num_2 = res.data.state_1;
    //     this.num_2 = this.$global_msg.num_2;
    //   });
    myAxios
      .get(`/client_media/OrderQuestions/v1?username=${this.username}`)
      .then(res => {
        this.$global_msg.num_4 = res.data.state_1;
        this.num_4 = this.$global_msg.num_4;
      });
    // myAxios
    //   .get(
    //     `/client_login/MyOrder/v1?username=${this.username}&index=1&size=20`
    //   )
    //   .then(res => {
    //     this.$global_msg.num_3 =
    //       res.data.state_1 + res.data.state_2 + res.data.state_4;
    //        this.num_3 = this.$global_msg.num_3;
    //   });
  }
};
</script>


<style lang="less" scoped>
@import "../style/mixin";
.manage_page {
}
.red {
  color: #ffffff;
}
</style>
